<template>
  <div class="container-fluid">
    <div class="row" style="padding-left: 30px; padding-right: 30px">
      <div class="col-12">
        <div class="sub-title" style="display: flex">
          Recycling
          <div
            class="link tooltip-wrapper"
            v-tooltip="{
              content: recycleTooltip,
              class: 'mytooltip',
            }"
          >
            <img src="static/img/graphInfo.svg" class />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row"
      style="padding-left: 30px; padding-right: 30px; margin-bottom: 10px"
    >
      <div class="col-12 sub-info">
        Fund Size : ${{ formatNumberWithComma(totalFundSize) }}
      </div>
    </div>

    <div class="row values-wrapper">
      <div class="col-6">
        <card class="info-section">
          <div class="section-wrapper" style="min-height: 107px">
            <div class="flex-row">
              <div class="label">Total Capital Deployed</div>

              <div class="value pointer" id="totCapDepId">
                ${{ formatNumberWithComma(totalCapitalDeployed) }}
              </div>

              <b-popover
                target="totCapDepId"
                triggers="hover"
                placement="topright"
                custom-class
              >
                <div class="">
                  {{ totalCapitalTooltip }}<br />
                  <b>{{ this.totalCapitalDeployedAsMultiple }}x</b>
                </div>
              </b-popover>
            </div>

            <div class="flex-row">
              <div class="label">Target Capital To Deploy In Fund</div>

              <div class="value pointer" id="tarCapToDepFndId">
                ${{ formatNumberWithComma(targetCapitalToDeployInFund) }}
              </div>

              <b-popover
                target="tarCapToDepFndId"
                triggers="hover"
                placement="topright"
                custom-class
              >
                <div class="">
                  {{ targetCapitalTooltip }}<br />
                  <b>{{ formatNumberWithComma(this.targetCapitaToDeployAsMultiple) }}x</b>
                </div>
              </b-popover>
            </div>

            <div class="flex-row">
              <div class="label">Capital Left To Deploy</div>

              <div class="value">
                ${{ formatNumberWithComma(leftToDeploy) }}
              </div>
            </div>
          </div>
        </card>
      </div>
      <div class="col-6">
        <card class="info-section">
          <i
            class="fa fa-pencil link float-right"
            @click="handleTargetRecycleFactorShow()"
          ></i>
          <div class="section-wrapper">
            <div class="flex-row">
              <div class="label">Total Money Recycled</div>

              <div class="value pointer" id="totMoneyRecycledId">
                ${{ formatNumberWithComma(totalMoneyRecycled) }}
              </div>
              <b-popover
                target="totMoneyRecycledId"
                triggers="hover"
                placement="topright"
                custom-class
              >
                <div class="">
                  Sum of all realized cash proceeds that did not get distributed
                </div>
              </b-popover>
            </div>
            <div class="flex-row">
              <div class="label">Total Money Left To Recycle</div>

              <div class="value">
                ${{ formatNumberWithComma(totalMoneyLeftToRecycle) }}
              </div>
            </div>

            <div class="flex-row">
              <div class="label">Fee & Expense Load Assumption %</div>

              <div class="value pointer" id="feeExpId">
                {{ formatNumberWithComma(feeAndExpenseLoadAssumptionPercent) }}
              </div>

              <b-popover
                target="feeExpId"
                triggers="hover"
                placement="topright"
                custom-class
              >
                <div class="">
                  <b
                    >${{
                      formatNumberWithComma(
                        this.feeAndExpenseLoadAssumptionAmount
                      )
                    }}</b
                  >
                </div>
              </b-popover>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          class="tabulator recycled-table"
          ref="table"
          v-if="refresh"
          style="width: 100%; height: 100%"
        ></div>
      </div>
    </div>

    <el-dialog
      left
      title="Edit"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="470px"
      :visible.sync="showTargetRecycleFactorDialog"
      @close="handleTargetRecycleFactorCancel"
      class="ipo-modal"
    >
      <div class="col-12 w-100" style="min-width: 430px">
        <form @submit.prevent="targetRecycleFactorSave">
          <div>
            <div class="row">
              <div class="col-12">
                <div>Target Capital to Deploy Percent</div>
                <input
                  type="number"
                  class="form-control team-form"
                  style="width: 100%"
                  step="1"
                  v-model="targetCapitalToDeployPercentInForm"
                  placeholder=""
                  min="0"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div>Fee & Expense Load Assumption Percent</div>
                <input
                  type="number"
                  class="form-control team-form"
                  style="width: 100%"
                  step="1"
                  v-model="feeAndExpenseLoadAssumptionPercentInForm"
                  placeholder=""
                  min="0"
                />
              </div>
            </div>

            <div
              class="edit-company-action-button-row pt-3"
              style="margin: 0px"
            >
              <button
                type="button"
                @click="handleTargetRecycleFactorCancel()"
                class="todo-form-cancel-button btn-outline-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="todo-form-submit-button btn btn-primary"
                style="height: 35px"
              >
                Save
                <b-spinner
                  v-if="isTargetRecycleFactorSaving"
                  style="float: right"
                  small
                  label="Loading..."
                ></b-spinner>
              </button>
            </div>
          </div>
        </form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Tabulator from "tabulator-tables";
import CustomMenu from "../Components/CustomMenu.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import ShareDocument from "../Dialogs/ShareDocument";
import { Select, Option, Dialog } from "element-ui";
import api from "../../../axios_api";
import config from "../../../../config/settings";
import { vals, formatNumberWithComma } from "../../../util";
import AddFormationDocument from "../Dialogs/AddFormationDocument";
import EditFormationDocument from "../Dialogs/EditFormationDocument";

const DATA_STATUS_CONFIRMED = "Confirmed";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";
export default {
  name: "recyclingTab",
  components: {
    [CustomMenu.name]: CustomMenu,
    [Dialog.name]: Dialog,
  },
  props: {
    context: String,
  },
  data() {
    return {
      refresh: true,

      showTargetRecycleFactorDialog: false,
      targetCapitalToDeployPercent: 0,
      feeAndExpenseLoadAssumptionPercent: 20,
      feeAndExpenseLoadAssumptionAmount: 0,
      targetCapitalToDeployPercentInForm: 0,
      feeAndExpenseLoadAssumptionPercentInForm: 20,

      targetRecycleFactorInForm: 0,
      isTargetRecycleFactorSaving: false,

      totalCapitalDeployed: 0,
      totalCapitalDeployedAsMultiple: 0,
      targetCapitalToDeployInFund: 0,
      targetCapitaToDeployAsMultiple: 0,
      leftToDeploy: 0,
      totalMoneyRecycled: 0,
      totalMoneyLeftToRecycle: 0,

      totalFundSize: 0,
    };
  },
  computed: {
    ...mapGetters("portfolio", [
      "portfolioData",
      "hasData",
      "portfolioAll",
      "dataLoaded",
    ]),
    ...mapGetters("workspace", ["currentWorkspace"]),
    ...mapGetters("role", ["checkRole"]),
    ...mapGetters("lpAllocations", ["summaryData", "thesisData"]),

    tableData() {
      return this.getTableData();
    },

    formatNumberWithComma() {
      return formatNumberWithComma;
    },

    totalCapitalTooltip() {
      return `Total Capital Deployed as Multiple: `;
    },

    targetCapitalTooltip() {
      return `Target Capital To Deploy as Multiple: `;
    },

    recycleTooltip() {
      return `
            <div style="width: 90vw;">
                <table class="tooltip-table">
                    <tr>
                        <td>Fund size</td>
                        <td>Total capital raised by the fund (entered by user when adding a fund in system)</td>
                    </tr>
                    <tr>
                        <td>Recycling</td>
                        <td>To reinvest (recycle) realized proceeds into new investments/follow-ons</td>
                    </tr>
                    <tr>
                        <td>Full Recycle</td>
                        <td>Term used to describe that you want to deploy 100% of your fund size into investments</td>
                    </tr>
                    <tr>
                        <td>Target capital to deploy as a % of fund size</td>
                        <td>User enters a percentage of the fund size that they want to deploy into investments. I.e. if they enter 100% and they have a $100M fund, then they want their total capital deployed to equal $100M</td>
                    </tr>
                    <tr>
                        <td>Target capital to deploy in fund</td>
                        <td>Fund size times times the target capital to deploy percentage entered by the user</td>
                    </tr>
                    <tr>
                        <td>Total capital deployed</td>
                        <td>Sum of all dollars deployed into investment from a specific fund (cost of investments in that fund)</td>
                    </tr>
                    <tr>
                        <td>Capital left to deploy (to get to target)</td>
                        <td>Target capital to deploy minus total capital deployed</td>
                    </tr>
                    <tr>
                        <td>Total money recycled</td>
                        <td>Sum of all realized cash proceeds that did not get distributed</td>
                    </tr>
                    <tr>
                        <td>Mgmt fee & fund expense load assumption as a %</td>
                        <td>20% is a fairly standard assumption for mgmt fees & expenses charged to the fund, but making this an input gives the user better control over this based on their mgmt fee % and knowledge of their fund expenses over time</td>
                    </tr>
                    <tr>
                        <td>Total money left to recycle</td>
                        <td>Target capital to deploy in fund + fee & expense load assumption - fund size - total money recycled</td>
                    </tr>
                </table>
            </div>
        `;
    },
  },
  methods: {
    init() {
      let self = this;
      self.refresh = true;

      self.setCompanyTable();

      self.feeAndExpenseLoadAssumptionPercent =
        self.currentWorkspace.feeAndExpenseLoadAssumptionPercent || 20;
      self.targetCapitalToDeployPercent =
        self.currentWorkspace.targetCapitalToDeployPercent;

      self.calculateTotals();
    },

    setCompanyTable() {
      let self = this;

      self.tabulator = new Tabulator(self.$refs.table, {
        layout: "fitColumns",
        index: "id",
        tooltips: true,
        layoutColumnsOnNewData: true,
        //adjustTableSize: true,
        virtualDom: false,
        height: "100%",
        responsiveLayout: "collapse",
        responsiveLayoutCollapseStartOpen: true,
        data: self.tableData,
        columns: [
          {
            title: "Company Name",
            field: "nameLogoString",
            formatter: "html",
            tooltip: function (cell) {
              let tootipData = `${cell._cell.row.data.name} - ${cell._cell.row.data.status}`;
              return tootipData;
            },
            cellClick: function (e, cell) {
              if (
                [DATA_STATUS_CONFIRMED, DATA_STATUS_UPDATING].indexOf(
                  cell.getData()["data_status"]
                ) == -1
              ) {
                return;
              }
              // set the 'current company' and go to the company profile
              let name = cell.getData().name;
              // get the ucid
              let ucid = _.reduce(
                self.portfolioData,
                (memo, data) => {
                  if (data.name == name) return data.ucid;
                  return memo;
                },
                -1
              );
              // save our current company and go to the profile page
              self.$store.commit("temp/currentCompany", ucid);
              self.$router.push(
                `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
              );
            },
          },
          {
            title: "Cash Proceeds",
            field: "cashProceeds",
            // width: "20"
          },
          {
            title: "Distributed",
            field: "distributed",
            // width: "20"
          },

          {
            title: "Recycled",
            field: "recycled",
            // width: "20"
          },
        ],
        pagination: "local",
        paginationSize: 100,
        paginationSizeSelector: true,
        placeholder: "No records to view",
      });

      setTimeout(() => {
        this.tabulator.redraw();
      }, 2000);
    },

    getTableData() {
      const self = this;

      let items = _.map(self.portfolioData, (data, index) => {
        if (Number.isInteger(data.cost)) {
          self.totalCapitalDeployed += data.cost;
        }

        if (["IPO", "Acquired"].includes(data.status)) {
          if (data.ipo_info || data.acquisition_info) {
            if (
              data.ipo_info &&
              data.ipo_info.ipoRecycled &&
              data.ipo_info.ipoRecycled > 0
            ) {
              self.totalMoneyRecycled += parseInt(data.ipo_info.ipoRecycled);
            }
            if (
              data.acquisition_info &&
              data.acquisition_info.acquisitionRecycle &&
              data.acquisition_info.acquisitionRecycle > 0
            ) {
              self.totalMoneyRecycled += parseInt(
                data.acquisition_info.acquisitionRecycle
              );
            }
          }

          if (data.ipo_info) {
            data.cashProceeds =
              "$" +
              (data.ipo_info.ipoTotalProceeds
                ? formatNumberWithComma(data.ipo_info.ipoTotalProceeds)
                : 0);
            data.distributed =
              "$" +
              (data.ipo_info.ipoDistribution
                ? formatNumberWithComma(data.ipo_info.ipoDistribution)
                : 0);
            data.recycled =
              "$" +
              (data.ipo_info.ipoRecycled
                ? formatNumberWithComma(data.ipo_info.ipoRecycled)
                : 0);
          } else if (data.acquisition_info) {
            data.cashProceeds =
              "$" +
              (data.acquisition_info.acquisitionCashProceeds
                ? formatNumberWithComma(
                    data.acquisition_info.acquisitionCashProceeds
                  )
                : 0);
            data.distributed =
              "$" +
              (data.acquisition_info.acquisitionDistribution
                ? formatNumberWithComma(
                    data.acquisition_info.acquisitionDistribution
                  )
                : 0);
            data.recycled =
              "$" +
              (data.acquisition_info.acquisitionRecycle
                ? formatNumberWithComma(
                    data.acquisition_info.acquisitionRecycle
                  )
                : 0);
          } else {
            data.cashProceeds = "$" + 0;
            data.distributed = "$" + 0;
            data.recycled = "$" + 0;
          }
        }

        data.sector =
          data.sector && data.sector != "Unknown" ? data.sector : "-";
        data.logo_url = data.logo_url
          ? data.logo_url
          : "static/img/generic-logo.png";

        data.id = index;
        let logoUrl =
          data.hasOwnProperty("image_id") && data.image_id.length > 0
            ? `${config.CRUNCHBASE_IMAGE_URL}/${data.image_id}`
            : data.logo_url;
        if (data.data_status == DATA_STATUS_CONFIRMED) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/confirmed.svg" class="company-statys-img"/>
                            <b style="margin-left: 48px;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            }  </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>

            `;
        }
        if (data.data_status == DATA_STATUS_UNCONFIRMED) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }
        if (data.data_status == DATA_STATUS_UPDATING) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/retrieving.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }
        if (data.data_status == "NoCompanyUrl") {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }

        return data;
      });

      return items.filter((item) => {
        return ["IPO", "Acquired"].includes(item.status);
        // return item.ipo_info || item.acquisition_info;
      });
    },

    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },

    async targetRecycleFactorSave() {
      let self = this;

      self.isTargetRecycleFactorSaving = true;

      await api.put(
        `${self.$route.params.account_id}/${self.$route.params.workspace_id}/target-recycle-factor`,
        {
          encrypt: {
            data: {
              targetCapitalToDeployPercent:
                self.targetCapitalToDeployPercentInForm,
              feeAndExpenseLoadAssumptionPercent:
                self.feeAndExpenseLoadAssumptionPercentInForm,
            },
          },
        }
      );

      self.targetCapitalToDeployPercent = parseFloat(
        self.targetCapitalToDeployPercentInForm
      );
      self.feeAndExpenseLoadAssumptionPercent = parseFloat(
        self.feeAndExpenseLoadAssumptionPercentInForm
      );

      self.currentWorkspace.targetCapitalToDeployPercent =
        self.targetCapitalToDeployPercent;
      self.currentWorkspace.feeAndExpenseLoadAssumptionPercent =
        self.feeAndExpenseLoadAssumptionPercent;
      this.$store.commit(
        "workspace/setCurrentWorkspaceProfile",
        self.currentWorkspace
      );

      self.$store.dispatch("workspace/apiFetchworkspaces");

      self.calculateTotals();

      self.showTargetRecycleFactorDialog = false;

      self.isTargetRecycleFactorSaving = false;
    },
    handleTargetRecycleFactorCancel() {
      this.showTargetRecycleFactorDialog = false;
    },
    handleTargetRecycleFactorShow() {
      let self = this;
      self.targetCapitalToDeployPercentInForm =
        self.targetCapitalToDeployPercent;
      self.feeAndExpenseLoadAssumptionPercentInForm =
        self.feeAndExpenseLoadAssumptionPercent || 20;
      self.showTargetRecycleFactorDialog = true;
    },

    async calculateTotals() {
      let self = this;

      let k = await self.$store.dispatch(
        "lpAllocations/apiFetchCapitalCallData"
      );

      let fundDetailsData = await self.$store.getters[
        "lpAllocations/fundDetailsData"
      ];
      
      if (self.context === "gp") {
        if (
          fundDetailsData &&
          fundDetailsData.length &&
          fundDetailsData[0].capital_commitment
        ) {
          self.totalFundSize = parseFloat(
            fundDetailsData[0].capital_commitment
          ).toFixed(2);
        }
      } else {
        if (self.context === "lp") {
          self.totalFundSize = parseFloat(self.thesisData[0].size);
        }
      }

      self.totalCapitalDeployedAsMultiple = parseFloat(
        self.totalCapitalDeployed / parseFloat(self.totalFundSize)
      ).toFixed(2);

      self.targetCapitalToDeployInFund = parseFloat(
        self.totalFundSize * (self.targetCapitalToDeployPercent / 100)
      ).toFixed(2);

      self.targetCapitaToDeployAsMultiple =
        self.targetCapitalToDeployInFund / self.totalFundSize;

      self.leftToDeploy =
        parseFloat(self.targetCapitalToDeployInFund) -
        parseFloat(self.totalCapitalDeployed);

      self.feeAndExpenseLoadAssumptionAmount =
        self.totalFundSize * (self.feeAndExpenseLoadAssumptionPercent / 100);

      self.totalMoneyLeftToRecycle =
        parseFloat(self.targetCapitalToDeployInFund) +
        parseFloat(self.feeAndExpenseLoadAssumptionAmount) -
        parseFloat(self.totalFundSize) -
        parseFloat(self.totalMoneyRecycled);
    },
  },
  mounted() {
    let self = this;

    window.moment = moment;

    self.init();
  },
  watch: {
    tableData: {
      handler: function (newData) {},
    },
  },
};
</script>

<style scoped>
.sub-title {
  font: normal normal medium 14px/20px HelveticaNeue;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin: 20px 0;
}

.info-section {
  text-align: left;
  font: normal normal bold 16px/19px Helvetica Neue;
  letter-spacing: 0px;
  color: #00000080;
  text-transform: capitalize;
  opacity: 1;
  font-family: "custom-helvetica-medium", "roboto";
}
.info-section .flex-row {
  margin-bottom: 25px;
}
.section-wrapper {
  margin: 53px 15% 53px 15%;
}
.sub-info {
  font-weight: 100;
  font-size: 14px;
}
.values-wrapper .value {
  display: flex;
  align-items: center;
}
.tooltip-wrapper {
  margin-left: 10px;
}
</style>